import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';

import { State } from '../../../../vista-usuario/vista-usuario.state';

@Component({
  selector: 'rpe-vista-muestreador-container',
  templateUrl: './vista-muestreador-container.component.html',
  styleUrls: ['./vista-muestreador-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VistaMuestreadorContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  constructor(private store: Store<State>) {}

  ngOnInit(): void {
    // todo - hacer este dispatch singleton
  }
}
